import { combineTokens, makeSelectors } from '@utils/css';
import { colors } from '../../design-tokens/colors.js';

const tokens = combineTokens("--input-border", {
  dimmed: colors.gray.sim10(),
  hover: colors.gray.sim65(),
  focus: colors.gray.sim100(),
  backgroundColor: colors.gray.sim00()
});
const modifiers = makeSelectors({
  active: "dibamd98zq",
  empty: "dibe1nlrhnz",
  invalid: "dibiesevt",
  readOnly: "dibr1sfcfym",
  disabled: "dibd6qt5nm",
  labelAbove: "dibl1yw05n5"
});
const wrapper = "dibw1q9ymg3";
const labelAboveInput = "dibl1170u4v";
const inputWrapper = "dibiem04qi";
const content = "dibck4ldwy";
const labelOnInput = "diblx0rhrn";

// Responsible for "removing" the border of the input behind the label while the
// input has text
const borderClearer = "dibb1ypidgt";
const errorMessage = "dibe19wkafe";
const inputBorderSelectors = makeSelectors({
  wrapper: inputWrapper,
  label: labelOnInput
});

export { borderClearer, content, errorMessage, modifiers as inputBorderModifiers, inputBorderSelectors, tokens as inputBorderTokens, inputWrapper, labelAboveInput, labelOnInput, modifiers, tokens, wrapper };
import "./atom.input-border.style.linaria.module.css";
//# sourceMappingURL=atom.input-border.style.js.map
